export default "__VITE_ASSET__BT7Jn7JZ__"